import styled, { css } from 'styled-components';

type JustifyAlignment = 'auto' | 'stretch' | 'center' | 'start' | 'end' | 'left' | 'right';
type OverflowOptions = 'visible' | 'hidden' | 'clip' | 'scroll' | 'auto' | 'left' | 'right';

interface LayoutProps {
    /** @deprecated */
    $gap?: number;
    /** @deprecated */
    $overflow?: OverflowOptions;
    /** @deprecated */
    $margin?: string;
    /** @deprecated */
    $padding?: string;
    /** @deprecated */
    $wrapContent?: boolean;
    /** @deprecated */
    $stretch?: boolean;

    /** @deprecated */
    $rowStart?: boolean;
    /** @deprecated */
    $rowEnd?: boolean;
    /** @deprecated */
    $rowCenter?: boolean;

    /** @deprecated */
    $apart?: boolean;
    /** @deprecated */
    $width?: string;
    /** @deprecated */
    $height?: string;
    /** @deprecated */
    $flex?: string | number;
}
const Layout = styled.div<LayoutProps>`
    display: flex;
    ${(props) => props.$gap && `gap: ${props.$gap}px;`}
    ${(props) => props.$overflow && `overflow: ${props.$overflow}`};
    ${(props) => props.$margin && `margin: ${props.$margin};`}
    ${(props) => props.$padding && `padding: ${props.$padding};`}
    ${(props) => props.$wrapContent && 'flex-wrap: wrap;'}
    ${(props) => props.$stretch && 'width: 100%;'};
    ${(props) => props.$width && `width: ${props.$width};`};
    ${(props) => props.$height && `height: ${props.$height};`};
    ${(props) => props.$flex && `flex: ${props.$flex};`};
`;

interface HorizontalLayoutProps extends LayoutProps {
    /** @deprecated */
    $center?: boolean;
    /** @deprecated */
    $pullRight?: boolean;
    /** @deprecated */
    $alignItems?: JustifyAlignment;
}
export const HorizontalLayout = styled(Layout)<HorizontalLayoutProps>`
    flex-direction: row;
    ${(props) => props.$apart && 'justify-content: space-between;'}

    ${(props) => props.$center && 'justify-content: center;'}
    ${(props) => props.$pullRight && 'justify-content: flex-end;'}
    ${(props) => props.$alignItems && `align-items: ${props.$alignItems};`}

    ${(props) => props.$rowStart && 'align-items: flex-start;'};
    ${(props) => props.$rowCenter && 'align-items: center;'};
    ${(props) => props.$rowEnd && 'align-items: flex-end;'};
`;

interface VerticalLayoutProps extends LayoutProps {
    /** @deprecated */
    $columnStart?: boolean;
    /** @deprecated */
    $columnEnd?: boolean;
    /** @deprecated */
    $columnCenter?: boolean;
}
export const VerticalLayout = styled(Layout)<VerticalLayoutProps>`
    flex-direction: column;
    ${(props) => props.$columnStart && 'align-items: flex-start;'};
    ${(props) => props.$columnEnd && 'align-items: flex-end;'};
    ${(props) => props.$columnCenter && 'align-items: center;'};

    ${(props) => props.$rowStart && 'justify-content: flex-start;'};
    ${(props) => props.$rowCenter && 'justify-content: center;'};
    ${(props) => props.$rowEnd && 'justify-content: flex-end;'};

    ${(props) =>
        props.$apart &&
        `
            height: 100%;
            justify-content: space-between;
        `};
`;

export const Centered = styled.div<{ $stretch?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ $stretch }) =>
        $stretch
            ? css`
                  height: 100%;
                  width: 100%;
              `
            : ''}
`;

export const TwoColumnGrid = styled.div`
    height: 100%;
    display: grid;
    grid-template-columns: minmax(500px, 1fr) minmax(300px, 500px);
    column-gap: 64px;

    & > *:last-child {
        border-left: 1px solid ${({ theme }) => theme.border.light};
    }
`;
